import { useState } from "@wordpress/element";
import {
  SelectControl,
  __experimentalGrid as Grid,
  __experimentalHeading as Heading,
} from "@wordpress/components";

function Selector({ label, value, options, onChange }) {
  return (
    <div style={{ marginTop: "1rem" }}>
      <SelectControl
        label={label}
        value={value}
        options={[
          { label: `Select ${label}`, value: "" },
          ...options.map((opt) => ({
            label: opt === "" ? "—" : opt,
            value: opt,
          })),
        ]}
        onChange={onChange}
        __next40pxDefaultSize
        __nextHasNoMarginBottom
      />
    </div>
  );
}

function AmerequipForm({ data }) {
  const selectors = data.selectors ?? {};
  const allData = data.data ?? {};

  const selectorKeys = Object.keys(selectors);

  const [selectedValues, setSelectedValues] = useState(
    selectorKeys.reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {}),
  );

  const handleChange = (key) => (val) => {
    const updated = {
      ...selectedValues,
      [key]: val,
    };

    // Reset lower-level fields
    const keyIndex = selectorKeys.indexOf(key);
    selectorKeys.slice(keyIndex + 1).forEach((k) => {
      updated[k] = "";
    });

    setSelectedValues(updated);
  };

  // Build result key
  const selectedParts = selectorKeys.map((k) => selectedValues[k]);
  const fullKey = selectedParts.join(" | ");
  const trimmedKey = selectedParts.filter(Boolean).join(" | ");
  const result = allData[fullKey] ?? allData[trimmedKey] ?? null;

  // Dynamically get valid options for a selector based on previous values
  const getFilteredOptions = (currentKey) => {
    const currentIndex = selectorKeys.indexOf(currentKey);
    const filters = selectorKeys.slice(0, currentIndex);

    const matchingKeys = Object.keys(allData).filter((key) => {
      const parts = key.split(" | ");
      return filters.every((filterKey, i) => {
        const selected = selectedValues[filterKey];
        return !selected || parts[i] === selected;
      });
    });

    const values = new Set();
    for (const key of matchingKeys) {
      const parts = key.split(" | ");
      const val = parts[currentIndex] ?? "";
      values.add(val);
    }

    return Array.from(values);
  };

  return (
    <div className="amerequip-form">
      <Grid columns={2} gap={8}>
        <div>
          <Heading level={4}>Select Configuration</Heading>

          {selectorKeys.map((key) => (
            <Selector
              key={key}
              label={key}
              value={selectedValues[key]}
              options={getFilteredOptions(key)}
              onChange={handleChange(key)}
            />
          ))}
        </div>
        <div>
          <Heading level={4}>Part Numbers</Heading>
          <div style={{ marginTop: "2rem" }}>
            {!result && (
              <p>
                <em>Select configuration to view part numbers</em>
              </p>
            )}
            {result && (
              <div>
                <p>
                  <strong>Amerequip:</strong> {result?.Amerequip || "—"}
                </p>
                <p>
                  <strong>John Deere:</strong> {result["John Deere"] || "—"}
                </p>
              </div>
            )}
          </div>
        </div>
      </Grid>
    </div>
  );
}

export { AmerequipForm };
